import React from 'react';
import { get } from 'lodash';
import { Indicator } from '../styled';
import { Timestamp, Actions } from '../shared';

const columns = [
  {
    key: 'indicator',
    dataKey: 'sent',
    title: '',
    width: 30,
    cellRenderer: ({ cellData: sent }) => {
      if (sent !== undefined) {
        return <Indicator sent={sent} />;
      }
      return null;
    },
  },
  {
    key: 'name',
    dataKey: 'name',
    title: 'Alert Name',
    width: 300,
  },
  {
    key: 'filter',
    dataKey: 'filter.name',
    title: 'Filter',
    width: 200,
  },
  {
    key: 'condition',
    dataKey: 'condition',
    title: 'Condition',
    width: 300,
  },
  {
    key: 'sample',
    dataKey: 'sample',
    title: 'Sample',
    width: 150,
  },
  {
    key: 'time',
    dataKey: 'time',
    title: 'Last Event Time',
    width: 300,
    cellRenderer: ({ cellData: time, rowData: { source } }) => {
      const event0 = get(source, 'events.0', {});
      return time !== '-' ? <Timestamp id={event0.id || source.id} timestamp={time} /> : '-';
    },
  },
  {
    key: 'actions',
    dataKey: 'actions',
    title: '',
    width: 50,
    frozen: 'right',
    cellRenderer: ({ rowData, cellData: actions }) => {
      if (!actions) {
        return null;
      }
      const { source: alert } = rowData;
      return <Actions alert={alert} />;
    },
  },
];

export default columns;
